
<template>
  <div>
     <b-button
      v-permission="'rental_spaces.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon
        icon="PlusIcon"
        class="mr-50"/>
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>
    <Grid
      :service="service"
      route_name="rental_spaces"
      order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('name') }}</vs-th>
        <vs-th key="category" sort-key="category_name">{{ $t('rental_space.category') }}</vs-th>
        <vs-th key="description" sort-key="description">{{ $t('description') }}</vs-th>
        <vs-th key="sale">{{ $t('catalog.listing.column') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="25%" key="name">
            <div> {{ tr.name }}</div>
          </vs-td>
          <vs-td width="20%" key="category">
            <div> {{ tr.category.name }}</div>
          </vs-td>
          <vs-td width="30%" key="description">
            <div v-html-safe="tr.description"></div>
          </vs-td>
          <vs-td width="12%" key="sale">
            <div class="flex flex-row gap-2 items-center">
              <sale-status-badge :sale="saleMap[tr.id]"/>
              <feather-icon
                v-if="!isPublished(tr.id)"
                v-permission="'rental_spaces.edit'"
                icon="PlayCircleIcon"
                class="h-5 w-5 stroke-current text-primary cursor-pointer"
                v-tooltip.auto="{ content: $t('catalog.listing.resume'), delay: { show: 500, hide: 100 } }"
                @click="resumeSale(tr.id)"/>
              <a
                v-else-if="listingUrl(tr.id)"
                :href="listingUrl(tr.id)"
                target="_blank"
                rel="noopener"
                v-tooltip.auto="{ content: $t('catalog.listing.see'), delay: { show: 500, hide: 100 } }">
                <feather-icon icon="ExternalLinkIcon" class="h-5 w-5 stroke-current text-success"/>
              </a>
            </div>
          </vs-td>
          <vs-td width="8%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'rental_spaces.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'rental_spaces.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import RentalSpaceService from '@/services/api/RentalSpaceService'
import ProductService from '@/services/api/ProductService'
import SaleStatusBadge from '@/components/catalog/SaleStatusBadge.vue'
import { marketplaceItemUrl } from '@/components/catalog/catalog'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    SaleStatusBadge
  },
  data: () => ({
    selected: [],
    service: null,
    /** espaço id → linha do mapa item→produto (situação de venda). */
    saleMap: {}
  }),
  methods: {
    addNew() {
      this.$router.push('/rental_spaces/create')
    },
    resumeSale(id) {
      this.$router.push(`/rental_spaces/${id}/edit?step=venda`)
    },
    isPublished(id) {
      const sale = this.saleMap[id]
      return !!sale && sale.status === 'RE'
    },
    listingUrl(id) {
      const sale = this.saleMap[id]
      return sale ? marketplaceItemUrl('RSP', sale.product_id) : null
    },
    loadSaleMap() {
      ProductService.build(this.$vs).getItemsMap('RSP').then(rows => {
        const map = {}
        ;(Array.isArray(rows) ? rows : []).forEach(row => {
          if (!map[row.model_id] || row.status === 'RE') {
            map[row.model_id] = row
          }
        })
        this.saleMap = map
      }).catch(() => {})
    }
  },
  beforeMount() {
    this.service = RentalSpaceService.build(this.$vs)
  },
  mounted() {
    this.loadSaleMap()
  }
}
</script>
